import React from 'react'
import PropTypes from 'prop-types'
import css from './Row.module.css'
import cx from 'classnames'

const Row = ({ label, children, evenColored = false, skeleton = false, ...props }) => (
  <div key={label} className={cx(css.row, evenColored ? css.evenColored : css.oddColored)} {...props}>
    <div className={css.innerRow}>
      {skeleton && <div className={css.label} style={{ opacity: '0.2' }}>{`\u2586\u2586\u2586\u2586\u2586`}</div>}
      {label && <div className={css.label}>{label}</div>}
      <div className={css.value} title={typeof children === 'string' ? children : ''}>{children}</div>
    </div>
  </div>
)

Row.propTypes = {
  label: PropTypes.string
}

Row.displayName = 'Row'

export default Row



// WEBPACK FOOTER //
// ./components/Customers/presentational/Row.js